import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import useIntervalTimer from 'hooks/useIntervalTimer';

// This hook returns multiple event handlers which can be used to detect when
// the user has performed a medium and long press, firing one callback after a
// short delay and another after a longer delay.

const useMediumAndLongPress = t0 => {
  const $ = _c(23);
  const {
    onClick,
    onMediumPress,
    onLongPress,
    mediumPressDelay: t1,
    longPressDelay: t2
  } = t0;
  const mediumPressDelay = t1 === undefined ? 500 : t1;
  const longPressDelay = t2 === undefined ? 3000 : t2;
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const [hasMediumPressed, setHasMediumPressed] = useState(false);
  const [hasLongPressed, setHasLongPressed] = useState(false);
  let t3;
  let t4;
  if ($[0] !== hasMediumPressed || $[1] !== onMediumPress) {
    t3 = () => {
      if (hasMediumPressed) {
        onMediumPress?.();
      }
    };
    t4 = [hasMediumPressed, onMediumPress];
    $[0] = hasMediumPressed;
    $[1] = onMediumPress;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[4] !== hasLongPressed || $[5] !== onLongPress) {
    t5 = () => {
      if (hasLongPressed) {
        onLongPress?.();
      }
    };
    t6 = [hasLongPressed, onLongPress];
    $[4] = hasLongPressed;
    $[5] = onLongPress;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  useEffect(t5, t6);
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setStartTime(Date.now());
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const onStartPressing = t7;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setIsTouchDevice(true);
      onStartPressing();
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const onStartPressingTouch = t8;
  let t9;
  if ($[10] !== mediumPressDelay || $[11] !== onClick || $[12] !== startTime) {
    t9 = () => {
      if (!startTime) {
        return;
      }
      if (Date.now() - startTime < mediumPressDelay) {
        onClick?.();
      }
      setStartTime(null);
      setHasMediumPressed(false);
      setHasLongPressed(false);
    };
    $[10] = mediumPressDelay;
    $[11] = onClick;
    $[12] = startTime;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const onStopPressing = t9;
  let t10;
  if ($[14] !== longPressDelay || $[15] !== mediumPressDelay || $[16] !== startTime) {
    t10 = () => {
      const updatedHasMediumPressed = startTime && Date.now() - startTime >= mediumPressDelay;
      const updatedHasLongPressed = startTime && Date.now() - startTime >= longPressDelay;
      setHasMediumPressed(updatedHasMediumPressed);
      setHasLongPressed(updatedHasLongPressed);
    };
    $[14] = longPressDelay;
    $[15] = mediumPressDelay;
    $[16] = startTime;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  useIntervalTimer(t10, startTime ? 50 : null, true);
  const t11 = !isTouchDevice ? onStartPressing : undefined;
  let t12;
  if ($[18] !== hasLongPressed || $[19] !== hasMediumPressed || $[20] !== onStopPressing || $[21] !== t11) {
    t12 = {
      onMouseDown: t11,
      onMouseLeave: onStopPressing,
      onMouseUp: onStopPressing,
      onTouchEnd: onStopPressing,
      onTouchStart: onStartPressingTouch,
      hasMediumPressed,
      hasLongPressed
    };
    $[18] = hasLongPressed;
    $[19] = hasMediumPressed;
    $[20] = onStopPressing;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
};
export default useMediumAndLongPress;